/* eslint-disable react/prop-types */
import React, { useEffect, useState } from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import ImageWithBasePath from "../../../../core/img/imagewithbasebath";
import { Link } from "react-router-dom";
import { ChevronUp, RotateCcw } from "feather-icons-react/build/IconComponents";
import { setToogleHeader } from "../../../../core/redux/action";
import NewTask from "./NewTask";
import Table from "../../../../core/pagination/datatable";
import TaskDetailDrawer from "./TaskDetailDrawer";
import { Spin, Select, Skeleton, message } from "antd";
import { BASE_CRM_URL } from "../../../components/config/config";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import Swal from "sweetalert2";
import { fetchStaffDropdown } from "./taskApi";

// const { Option } = Select;

const BADGE_COLORS = {
  success: { background: "#E8F8F0", color: "#198754" },
  primary: { background: "#E7F1FF", color: "#0D6EFD" },
  warning: { background: "#FFF4DE", color: "#B26A00" },
  danger: { background: "#FDECEC", color: "#DC3545" },
  info: { background: "#E8F7FA", color: "#0DCAF0" },
  secondary: { background: "#F1F1F4", color: "#6B7280" },
};

const BadgeSelectStyles = () => (
  <style>
    {Object.entries(BADGE_COLORS)
      .map(
        ([key, { background, color }]) => `
          .badge-select-${key} .ant-select-selector {
            background-color: ${background} !important;
            color: ${color} !important;
            border: none !important;
            border-radius: 20px !important;
            box-shadow: none !important;
          }
          .badge-select-${key} .ant-select-selection-item {
            color: ${color} !important;
            font-weight: 600;
            font-size: 12px;
          }
          .badge-select-${key} .ant-select-arrow {
            color: ${color} !important;
          }
        `,
      )
      .join("\n")}
  </style>
);

const CRMTasks = () => {
  const dispatch = useDispatch();

  const isHeaderCollapsed = useSelector(
    (state) => state.rootReducer.toggle_header,
  );

  const [tasks, setTasks] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  // Add Task drawer
  const [isAddOpen, setIsAddOpen] = useState(false);

  // Merged Edit/View drawer
  const [detailDrawer, setDetailDrawer] = useState({
    open: false,
    mode: "view",
    taskId: null,
  });

  const [statusOptions, setStatusOptions] = useState([]);

  console.log(statusOptions, "stautsoptionsssssssssssssss");
  const [statusOptionsLoading, setStatusOptionsLoading] = useState(false);
  const [updatingStatusTaskId, setUpdatingStatusTaskId] = useState(null);

  const [priorityOptions, setPriorityOptions] = useState([]);
  console.log(priorityOptions);
  const [priorityOptionsLoading, setPriorityOptionsLoading] = useState(false);
  const [updatingPriorityTaskId, setUpdatingPriorityTaskId] = useState(null);

  const [taskCounts, setTaskCounts] = useState([]);
  const [countsLoading, setCountsLoading] = useState(true);
  const [exportLoading, setExportLoading] = useState(false);
  const [staffOptions, setStaffOptions] = useState([]);
  const [selectedStaff, setSelectedStaff] = useState(0);
  const [selectedStatus, setSelectedStatus] = useState(0);

  useEffect(() => {
    fetchStaffDropdown()
      .then(setStaffOptions)
      .catch((err) => console.error("Failed to load staff dropdown", err));
  }, []);

  const avatarColors = [
    { background: "#E7F1FF", color: "#0D6EFD" },
    { background: "#E8F8F0", color: "#198754" },
    { background: "#FFF4DE", color: "#FF9800" },
    { background: "#FDECEC", color: "#DC3545" },
    { background: "#E8F7FA", color: "#0DCAF0" },
    { background: "#F3E8FF", color: "#6F42C1" },
  ];

  const formatDate = (dateValue) => {
    if (!dateValue) {
      return "N/A";
    }

    const date = new Date(dateValue);

    if (Number.isNaN(date.getTime())) {
      return "N/A";
    }

    return date.toLocaleDateString("en-GB");
  };

  const getPriorityName = (priority) => {
    switch (Number(priority)) {
      case 1:
        return "Low";

      case 2:
        return "Medium";

      case 3:
        return "High";

      case 4:
        return "Urgent";

      default:
        return "N/A";
    }
  };

  const getAssignedStaff = (staffNames) => {
    if (!staffNames) {
      return [];
    }

    if (Array.isArray(staffNames)) {
      return staffNames;
    }

    return String(staffNames)
      .split(",")
      .map((name) => name.trim())
      .filter(Boolean);
  };

  const normalizeText = (value) =>
    String(value || "")
      .toLowerCase()
      .replace(/[\s-]/g, "");

  // const getStatusColorKey = (statusName) => {
  //   switch (normalizeText(statusName)) {
  //     case "complete":
  //     case "completed":
  //       return "success";

  //     case "testing":
  //       return "primary";

  //     case "inprogress":
  //       return "warning";

  //     case "notstarted":
  //       return "danger";

  //     case "awaitingfeedback":
  //       return "info";

  //     default:
  //       return "secondary";
  //   }
  // };

  // const getPriorityColorKey = (priorityName) => {
  //   switch (normalizeText(priorityName)) {
  //     case "low":
  //       return "success";

  //     case "medium":
  //       return "primary";

  //     case "high":
  //       return "warning";

  //     case "urgent":
  //       return "danger";

  //     default:
  //       return "secondary";
  //   }
  // };

  const getStatusIdByName = (statusName) => {
    const match = statusOptions.find(
      (option) => normalizeText(option.Status) === normalizeText(statusName),
    );

    return match ? match.Id : undefined;
  };

  // const getPriorityOptionById = (priorityId) =>
  //   priorityOptions.find(
  //     (option) => Number(option.priorityid) === Number(priorityId),
  //   );

  const fetchTaskStatuses = async () => {
    try {
      setStatusOptionsLoading(true);

      const response = await fetch(`${BASE_CRM_URL}tasks/GetTaskStatus`);

      if (!response.ok) {
        throw new Error(`Request failed with status ${response.status}`);
      }

      const result = await response.json();

      const options = Array.isArray(result?.ResultData)
        ? result.ResultData
        : [];

      setStatusOptions(options);
    } catch (error) {
      console.error("Error fetching task statuses:", error);

      setStatusOptions([]);
    } finally {
      setStatusOptionsLoading(false);
    }
  };

  const fetchPriorities = async () => {
    try {
      setPriorityOptionsLoading(true);

      const response = await fetch(`${BASE_CRM_URL}GetPriorities`);

      if (!response.ok) {
        throw new Error(`Request failed with status ${response.status}`);
      }

      const result = await response.json();

      const options = Array.isArray(result?.ResultData)
        ? result.ResultData
        : [];

      setPriorityOptions(options);
    } catch (error) {
      console.error("Error fetching priorities:", error);

      setPriorityOptions([]);
    } finally {
      setPriorityOptionsLoading(false);
    }
  };

  const fetchTaskCounts = async () => {
    try {
      setCountsLoading(true);
      const userDetails = JSON.parse(
        sessionStorage.getItem("userDetails") || "{}",
      );

      const response = await fetch(
        `${BASE_CRM_URL}tasks/GetTaskCounts?staffid=${userDetails?.staffid}`,
      );

      if (!response.ok) {
        throw new Error(`Request failed with status ${response.status}`);
      }

      const result = await response.json();

      const counts = Array.isArray(result?.ResultData) ? result.ResultData : [];

      setTaskCounts(counts);
    } catch (error) {
      console.error("Error fetching task counts:", error);

      setTaskCounts([]);
    } finally {
      setCountsLoading(false);
    }
  };

  const fetchTasks = async () => {
    try {
      setIsLoading(true);

      const response = await fetch(
        `${BASE_CRM_URL}tasks/GetTasksnew?assigned=${selectedStaff}&status=${selectedStatus}`,
      );

      if (!response.ok) {
        throw new Error(`Request failed with status ${response.status}`);
      }

      const result = await response.json();

      const apiTasks = Array.isArray(result?.ResultData)
        ? result.ResultData
        : [];

      const formattedTasks = apiTasks.map((task) => ({
        ...task,

        start_date: formatDate(task.startdate),
        due_date: formatDate(task.duedate),

        assigned_to: getAssignedStaff(task.staff_names),

        tags: task.tag_name ? [task.tag_name] : [],

        priority_name: getPriorityName(task.priority),
      }));

      setTasks(formattedTasks);
    } catch (error) {
      console.error("Error fetching tasks:", error);

      setTasks([]);
    } finally {
      setIsLoading(false);
    }
  };

  const updateTaskStatus = async (taskId, statusId) => {
    try {
      setUpdatingStatusTaskId(taskId);

      const response = await fetch(`${BASE_CRM_URL}tasks/UpdateTaskStatus`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          Id: taskId,
          status: statusId,
        }),
      });

      if (!response.ok) {
        throw new Error(`Request failed with status ${response.status}`);
      }

      const result = await response.json();

      if (result?.Status === false) {
        throw new Error(result?.Message || "Failed to update status");
      }

      Swal;

      await Promise.all([fetchTasks(), fetchTaskCounts()]);
    } catch (error) {
      console.error("Error updating task status:", error);

      message.error("Failed to update task status");
    } finally {
      setUpdatingStatusTaskId(null);
    }
  };

  const updateTaskPriority = async (taskId, priorityId) => {
    try {
      setUpdatingPriorityTaskId(taskId);

      const response = await fetch(`${BASE_CRM_URL}tasks/UpdateTaskPriority`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          Id: taskId,
          priority: priorityId,
        }),
      });

      if (!response.ok) {
        throw new Error(`Request failed with status ${response.status}`);
      }

      const result = await response.json();

      if (result?.Status === false) {
        throw new Error(result?.Message || "Failed to update priority");
      }

      message.success("Task priority updated successfully");

      await fetchTasks();
    } catch (error) {
      console.error("Error updating task priority:", error);

      message.error("Failed to update task priority");
    } finally {
      setUpdatingPriorityTaskId(null);
    }
  };

  useEffect(() => {
    fetchTaskStatuses();
    fetchPriorities();
    fetchTaskCounts();
  }, []);
  useEffect(() => {
    fetchTasks();
  }, [selectedStaff, selectedStatus]);

  const summaryCards = [
    {
      key: "notStarted",
      label: "Not Started",
      statusName: "Not Started",

      iconBg: "bg-secondary",
      textClass: "text-secondary",
      icon: "fa-solid fa-list-check",
    },
    {
      key: "inProgress",
      label: "In Progress",
      statusName: "In-Progress",

      iconBg: "bg-warning",
      textClass: "text-primary",
      icon: "fa-solid fa-spinner",
    },
    {
      key: "testing",
      label: "Testing",
      statusName: "Testing",

      iconBg: "bg-warning",
      textClass: "text-warning",
      icon: "fa-solid fa-flask",
    },
    {
      key: "Paused",
      label: "Paused",
      statusName: "Paused ",

      iconBg: "bg-info",
      textClass: "text-info",
      icon: "fa-solid fa-message",
    },
    {
      key: "completed",
      label: "Completed",
      statusName: "Completed",

      iconBg: "bg-success",
      textClass: "text-success",
      icon: "fa-solid fa-circle-check",
    },
  ];

  const getCountsForCard = (statusName) => {
    const match = taskCounts.find(
      (item) => normalizeText(item.Status) === normalizeText(statusName),
    );

    return {
      total: match?.TotalCount ?? 0,
      mine: match?.MyCount ?? 0,
    };
  };

  // ---- Add Task drawer handlers ----
  const openAddTask = () => setIsAddOpen(true);
  const closeAddTask = () => setIsAddOpen(false);
  const handleAddTaskSuccess = async () => {
    setIsAddOpen(false);
    await Promise.all([fetchTasks(), fetchTaskCounts()]);
    message.success("Task created successfully");
  };

  // ---- Edit/View drawer handlers ----
  const openTaskDetail = (mode, record) => {
    setDetailDrawer({ open: true, mode, taskId: record?.id });
  };
  const closeTaskDetail = () => {
    setDetailDrawer((prev) => ({ ...prev, open: false }));
  };
  const handleEditTaskSuccess = async () => {
    setDetailDrawer((prev) => ({ ...prev, open: false }));
    await Promise.all([fetchTasks(), fetchTaskCounts()]);
    message.success("Task updated successfully");
  };

  const columns = [
    // {
    //   title: "#",
    //   dataIndex: "id",
    //   sorter: (a, b) => Number(a.id) - Number(b.id),
    // },

    {
      title: "Subject",
      dataIndex: "name",

      sorter: (a, b) =>
        String(a.name || "").localeCompare(String(b.name || "")),

      render: (_, record) => (
        <div
          onClick={(event) => {
            event.preventDefault();
            openTaskDetail("view", record);
          }}
          style={{ cursor: "pointer" }}
        >
          <OverlayTrigger
            placement="top"
            overlay={<Tooltip>{record.name || "N/A"}</Tooltip>}
          >
            <strong>
              {record.name
                ? record.name.length > 45
                  ? `${record.name.substring(0, 45)}...`
                  : record.name
                : "N/A"}
            </strong>
          </OverlayTrigger>

          {record.description && (
            <>
              <br />

              <OverlayTrigger
                placement="top"
                overlay={<Tooltip>{record.description}</Tooltip>}
              >
                <span
                  style={{
                    color: "gray",
                    fontSize: "12px",
                  }}
                >
                  {record.description.length > 60
                    ? `${record.description.substring(0, 60)}...`
                    : record.description}
                </span>
              </OverlayTrigger>
            </>
          )}
        </div>
      ),
    },

    {
      title: "Status",
      dataIndex: "status",

      sorter: (a, b) =>
        String(a.status || "").localeCompare(String(b.status || "")),

      render: (status, record) => {
        const currentStatusId = getStatusIdByName(status);
        const isRowUpdating = updatingStatusTaskId === record.id;

        const getColor = (statusName) => {
          switch (
            String(statusName || "")
              .toLowerCase()
              .replace(/\s+/g, "")
          ) {
            case "complete":
            case "completed":
              return "#198754";

            case "testing":
              return "#0d6efd";

            case "inprogress":
              return "#ffc107";

            case "notstarted":
              return "#dc3545";

            case "awaitingfeedback":
              return "#0dcaf0";

            default:
              return "#6c757d";
          }
        };

        const selectedStatus = statusOptions.find(
          (item) => item.Id === currentStatusId,
        );

        const statusColor = getColor(selectedStatus?.Status || status);

        return (
          <Select
            value={currentStatusId}
            size="small"
            loading={statusOptionsLoading || isRowUpdating}
            disabled={isRowUpdating || statusOptionsLoading}
            style={{
              width: 130,
            }}
            styles={{
              selector: {
                border: `1px solid ${statusColor}`,
                borderRadius: "6px",
              },
            }}
            dropdownStyle={{
              zIndex: 9999,
            }}
            options={statusOptions.map((option) => ({
              value: option.Id,
              label: option.Status,
            }))}
            onChange={(newStatusId) => {
              if (newStatusId === currentStatusId) {
                return;
              }

              updateTaskStatus(record.id, newStatusId);
            }}
            optionRender={(option) => (
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                }}
              >
                <i
                  className="fa-solid fa-circle"
                  style={{
                    color: getColor(option.data.label),
                    fontSize: "9px",
                  }}
                />

                <span>{option.data.label}</span>
              </div>
            )}
            labelRender={() => (
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                }}
              >
                <i
                  className="fa-solid fa-circle"
                  style={{
                    color: statusColor,
                    fontSize: "9px",
                  }}
                />

                <span>
                  {selectedStatus?.Status || status || "Select status"}
                </span>
              </div>
            )}
          />
        );
      },
    },

    {
      title: "Start Date",
      dataIndex: "start_date",

      sorter: (a, b) =>
        String(a.start_date || "").localeCompare(String(b.start_date || "")),

      render: (date) => (
        <span>
          {/* <i className="fa-solid fa-calendar-plus text-primary me-2" /> */}
          {date || "N/A"}
        </span>
      ),
    },

    {
      title: "Due Date",
      dataIndex: "due_date",

      sorter: (a, b) =>
        String(a.due_date || "").localeCompare(String(b.due_date || "")),

      render: (date) => (
        <span>
          {/* <i className="fa-solid fa-calendar-check text-danger me-2" /> */}
          {date || "N/A"}
        </span>
      ),
    },

    {
      title: "Assigned",
      dataIndex: "assigned_to",

      render: (assignedTo = []) => (
        <div className="avatar-list-stacked d-flex">
          {assignedTo.length > 0 ? (
            assignedTo.map((name, index) => {
              const color = avatarColors[index % avatarColors.length];

              return (
                <span
                  key={`${name}-${index}`}
                  className="avatar avatar-rounded fw-bold d-flex justify-content-center align-items-center"
                  style={{
                    width: 35,
                    height: 35,
                    fontSize: 14,
                    backgroundColor: color.background,
                    color: color.color,
                  }}
                  title={name}
                >
                  {name.charAt(0).toUpperCase()}
                </span>
              );
            })
          ) : (
            <span className="text-muted">N/A</span>
          )}
        </div>
      ),

      sorter: (a, b) =>
        (a.assigned_to?.length || 0) - (b.assigned_to?.length || 0),
    },

    {
      title: "Priority",
      dataIndex: "priority_name",

      sorter: (a, b) =>
        String(a.priority_name || "").localeCompare(
          String(b.priority_name || ""),
        ),

      render: (priorityName, record) => {
        const currentPriorityId = record.priority
          ? Number(record.priority)
          : undefined;

        const isRowUpdating = updatingPriorityTaskId === record.id;

        const getColor = (priority) => {
          switch (
            String(priority || "")
              .toLowerCase()
              .replace(/\s+/g, "")
          ) {
            case "low":
              return "#198754"; // green

            case "medium":
              return "#ffc107"; // yellow

            case "high":
              return "#fd7e14"; // orange

            case "urgent":
              return "#dc3545"; // red

            default:
              return "#6c757d"; // gray
          }
        };

        const selectedPriority = priorityOptions.find(
          (item) => Number(item.priorityid) === Number(currentPriorityId),
        );

        const priorityColor = getColor(selectedPriority?.name || priorityName);

        return (
          <Select
            value={selectedPriority ? currentPriorityId : undefined}
            size="small"
            loading={priorityOptionsLoading || isRowUpdating}
            disabled={isRowUpdating || priorityOptionsLoading}
            style={{
              width: 95,
            }}
            styles={{
              selector: {
                border: `1px solid ${priorityColor}`,
                borderRadius: "6px",
              },
            }}
            dropdownStyle={{
              zIndex: 9999,
            }}
            options={priorityOptions.map((option) => ({
              value: option.priorityid,
              label: option.name,
            }))}
            onChange={(newPriorityId) => {
              if (Number(newPriorityId) === Number(currentPriorityId)) {
                return;
              }

              updateTaskPriority(record.id, newPriorityId);
            }}
            optionRender={(option) => (
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                }}
              >
                <i
                  className="fa-solid fa-circle"
                  style={{
                    color: getColor(option.data.label),
                    fontSize: "9px",
                  }}
                />

                <span>{option.data.label}</span>
              </div>
            )}
            labelRender={() => (
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                }}
              >
                <i
                  className="fa-solid fa-circle"
                  style={{
                    color: priorityColor,
                    fontSize: "9px",
                  }}
                />

                <span>
                  {selectedPriority?.name || priorityName || "Select priority"}
                </span>
              </div>
            )}
          />
        );
      },
    },

    {
      title: "Action",
      dataIndex: "action",

      render: (_, record) => (
        <>
          {/* <Link
            className="action-set"
            to="#"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            <i className="fa fa-ellipsis-v" aria-hidden="true" />
          </Link>

          <ul className="dropdown-menu">
            <li>
              <Link
                to="#"
                className="dropdown-item"
                onClick={(event) => {
                  event.preventDefault();
                  openTaskDetail("view", record);
                }}
              >
                <Eye className="info-img" />
                View
              </Link>
            </li>

            <li>
              <Link
                to="#"
                className="dropdown-item"
                onClick={(event) => {
                  event.preventDefault();
                  openTaskDetail("edit", record);
                }}
              >
                <Edit className="info-img text-info" />
                Edit
              </Link>
            </li>
          </ul> */}

          <div className="action-table-data">
            <div className="edit-delete-action ">
              {/* <Link
                to="#"
                 className="me-2 p-2  shadow-sm"
                onClick={(event) => {
                  event.preventDefault();
                  openTaskDetail("view", record);
                }}
              >
                  <i className="ti ti-eye text-info"></i>
              </Link> */}
              <Link
                to="#"
                className="me-2 p-2  shadow-sm"
                onClick={(event) => {
                  event.preventDefault();
                  openTaskDetail("edit", record);
                }}
              >
                <i className="ti ti-pencil text-primary"></i>
              </Link>
            </div>
          </div>
        </>
      ),
    },
  ];

  const renderRefreshTooltip = (props) => (
    <Tooltip id="refresh-tooltip" {...props}>
      Refresh
    </Tooltip>
  );

  const renderCollapseTooltip = (props) => (
    <Tooltip id="collapse-tooltip" {...props}>
      Collapse
    </Tooltip>
  );

  const exportTasksExcel = async () => {
    try {
      setExportLoading(true);

      const workbook = new ExcelJS.Workbook();
      const worksheet = workbook.addWorksheet("Tasks");

      // Columns
      worksheet.columns = [
        {
          header: "Task Name",
          key: "name",
          width: 30,
        },
        {
          header: "Description",
          key: "description",
          width: 45,
        },
        {
          header: "Priority",
          key: "priorityName",
          width: 15,
        },
        {
          header: "Status",
          key: "status",
          width: 18,
        },
        {
          header: "Start Date",
          key: "startdate",
          width: 22,
        },
        {
          header: "Due Date",
          key: "duedate",
          width: 22,
        },

        {
          header: "Date Added",
          key: "dateadded",
          width: 22,
        },

        {
          header: "Assigned To",
          key: "staff_names",
          width: 25,
        },
      ];

      // Add data
      tasks.forEach((task) => {
        worksheet.addRow({
          name: task.name ?? "",
          description: task.description ?? "",
          priorityName: task.priorityName ?? "",
          status: task.status ?? "",

          startdate: task.startdate
            ? new Date(task.startdate).toLocaleString("en-IN")
            : "",

          duedate: task.duedate
            ? new Date(task.duedate).toLocaleString("en-IN")
            : "",

          dateadded: task.dateadded
            ? new Date(task.dateadded).toLocaleString("en-IN")
            : "",

          staff_names: task.staff_names || "N/A",
        });
      });

      // Header styling
      const headerRow = worksheet.getRow(1);

      headerRow.font = {
        bold: true,
      };

      headerRow.alignment = {
        horizontal: "center",
        vertical: "middle",
      };

      headerRow.height = 22;

      // Borders and alignment
      worksheet.eachRow((row) => {
        row.eachCell((cell) => {
          cell.border = {
            top: { style: "thin" },
            left: { style: "thin" },
            bottom: { style: "thin" },
            right: { style: "thin" },
          };

          cell.alignment = {
            vertical: "middle",
            wrapText: true,
          };
        });
      });

      // Footer
      worksheet.headerFooter.oddFooter =
        "&CGenerated by Pereco | Powered by perennialcode" + "&RPage &P of &N";

      // Repeat header when printing
      worksheet.printTitlesRow = "1:1";

      // Page setup
      worksheet.pageSetup = {
        orientation: "landscape",
        paperSize: 9,
        fitToPage: true,
        fitToWidth: 1,
        fitToHeight: 0,
      };

      // Generate Excel
      const buffer = await workbook.xlsx.writeBuffer();

      const blob = new Blob([buffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });

      saveAs(blob, "Tasks.xlsx");
    } catch (error) {
      console.error("Tasks Excel export error:", error);

      Swal.fire("Error", "Failed to generate Tasks Excel file", "error");
    } finally {
      setExportLoading(false);
    }
  };

  const exportTasksPDF = () => {
    try {
      setExportLoading(true);

      const doc = new jsPDF({
        orientation: "landscape",
        unit: "mm",
        format: "a4",
      });

      const generatedOn = new Date().toLocaleString("en-IN");

      const columns = [
        "Task Name",
        "Description",
        "Priority",
        "Status",
        "Start Date",
        "Due Date",
        "Date Added",
        "Assigned To",
      ];

      const rows = tasks.map((task) => [
        task.name ?? "",
        task.description ?? "",
        task.priorityName ?? "",
        task.status ?? "",

        task.startdate ? new Date(task.startdate).toLocaleString("en-IN") : "",

        task.duedate ? new Date(task.duedate).toLocaleString("en-IN") : "",

        task.dateadded ? new Date(task.dateadded).toLocaleString("en-IN") : "",

        task.staff_names || "N/A",
      ]);

      // Report title - top center
      doc.setFontSize(16);
      doc.setFont("helvetica", "bold");

      doc.text("Tasks Report", 148, 12, {
        align: "center",
      });

      // Generated On - top right
      doc.setFontSize(9);
      doc.setFont("helvetica", "normal");

      doc.text(`Generated On: ${generatedOn}`, 291, 12, {
        align: "right",
      });

      // Table
      autoTable(doc, {
        head: [columns],
        body: rows,

        startY: 20,

        margin: {
          top: 20,
          bottom: 18,
          left: 6,
          right: 6,
        },

        theme: "grid",

        styles: {
          fontSize: 6.5,
          cellPadding: 2,
          valign: "middle",
          overflow: "linebreak",
        },

        headStyles: {
          fontSize: 7,
          fontStyle: "bold",
        },

        showHead: "everyPage",

        // Footer
        didDrawPage: () => {
          doc.setFontSize(8);
          doc.setFont("helvetica", "normal");

          doc.text("Generated by Pereco | Powered by perennialcode", 148, 200, {
            align: "center",
          });
        },
      });

      // Total pages
      const totalPages = doc.internal.getNumberOfPages();

      // Page X of Y
      for (let i = 1; i <= totalPages; i++) {
        doc.setPage(i);

        doc.setFontSize(8);
        doc.setFont("helvetica", "normal");

        doc.text(`Page ${i} of ${totalPages}`, 289, 200, {
          align: "right",
        });
      }

      doc.save("Tasks.pdf");
    } catch (error) {
      console.error("Tasks PDF export error:", error);

      Swal.fire("Error", "Failed to generate Tasks PDF file", "error");
    } finally {
      setExportLoading(false);
    }
  };

  return (
    <div className="page-wrapper">
      <BadgeSelectStyles />
      {exportLoading && (
        <div
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 1000,
            backgroundColor: "rgba(255, 255, 255, 0.8)",
          }}
        >
          <Spin size="large" tip="Processing..." />
        </div>
      )}
      <div className="content">
        {/* Page Header */}
        <div className="page-header">
          <div className="add-item d-flex">
            <div className="page-title">
              <nav aria-label="breadcrumb">
                <ol className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to="/crm/dashboard">
                      <i className="fas fa-home fa-lg" />
                    </Link>
                  </li>

                  <li className="breadcrumb-item" aria-current="page">
                    Tasks
                  </li>
                </ol>
              </nav>

              <h6>Manage your Tasks here</h6>
            </div>
          </div>

          <ul className="table-top-head">
            <li className="me-2">
              <Link onClick={exportTasksPDF}>
                <ImageWithBasePath src="assets/img/icons/pdf.svg" alt="img" />
              </Link>
            </li>
            <li className="me-2">
              <Link onClick={exportTasksExcel}>
                <ImageWithBasePath src="assets/img/icons/excel.svg" alt="img" />
              </Link>
            </li>{" "}
            <li>
              <OverlayTrigger placement="top" overlay={renderRefreshTooltip}>
                <Link
                  to="#"
                  onClick={(event) => {
                    event.preventDefault();

                    if (!isLoading) {
                      fetchTasks();
                      fetchTaskCounts();
                    }
                  }}
                >
                  <RotateCcw className={isLoading ? "spin-animation" : ""} />
                </Link>
              </OverlayTrigger>
            </li>
            <li>
              <OverlayTrigger placement="top" overlay={renderCollapseTooltip}>
                <Link
                  to="#"
                  id="collapse-header"
                  className={isHeaderCollapsed ? "active" : ""}
                  onClick={(event) => {
                    event.preventDefault();

                    dispatch(setToogleHeader(!isHeaderCollapsed));
                  }}
                >
                  <ChevronUp />
                </Link>
              </OverlayTrigger>
            </li>
          </ul>

          <div className="d-flex">
            <div>
              <Link
                to="#"
                title="Add Task"
                className="btn btn-success btn-sm text-white"
                onClick={(event) => {
                  event.preventDefault();
                  openAddTask();
                }}
              >
                <i className="ti ti-circle-plus fs-16" />
              </Link>
            </div>
          </div>
        </div>

        {/* Status Cards */}
        <div className="row g-3">
          {summaryCards.map((card) => {
            const { total, mine } = getCountsForCard(card.statusName);

            return (
              <div key={card.key} className="col-12 col-sm-6 col-xl d-flex">
                <div className={`card flex-fill ${card.border} shadow-sm`}>
                  <div className="card-body d-flex justify-content-between align-items-center py-2 px-3">
                    {countsLoading ? (
                      <Skeleton
                        active
                        title={false}
                        paragraph={{ rows: 2, width: ["70%", "50%"] }}
                        style={{ width: "100%" }}
                      />
                    ) : (
                      <>
                        <div className="d-flex align-items-center gap-2 text-nowrap">
                          <h6 className="mb-0 fw-bold">
                            {mine}/{total} {card.label}
                          </h6>
                        </div>

                        <div
                          className={`rounded-circle ${card.iconBg} bg-opacity-10 d-flex align-items-center justify-content-center`}
                          style={{ width: 45, height: 45 }}
                        >
                          <i
                            className={`${card.icon} ${card.textClass} fs-16`}
                          />
                        </div>
                      </>
                    )}
                  </div>
                </div>
              </div>
            );
          })}
        </div>

        {/* Table */}
        <div className="card table-list-card">
          <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
            <div className="search-set p-3"></div>

            <div className="d-flex table-dropdown my-xl-auto right-content align-items-center flex-wrap row-gap-3">
              <div className="me-2">
                <label className="form-label">Assigned to </label>
                <Select
                  className="w-100"
                  style={{ height: 38 }}
                  placeholder="Followers"
                  value={selectedStaff}
                  onChange={(value) => setSelectedStaff(value)}
                  options={[{ label: "All", value: 0 }, ...staffOptions]}
                />
              </div>
              <div className="">
                <label className="form-label">Status </label>

                <Select
                  className="w-100"
                  style={{ height: 38 }}
                  value={selectedStatus}
                  onChange={(value) => setSelectedStatus(value)}
                  options={[
                    { value: 0, label: "All" },
                    ...statusOptions.map((option) => ({
                      value: option.Id,
                      label: option.Status,
                    })),
                  ]}
                />
              </div>
            </div>
          </div>

          <div className="card-body">
            <div className="table-responsive">
              {isLoading ? (
                <div
                  className="d-flex justify-content-center align-items-center py-5"
                  style={{ minHeight: "250px" }}
                >
                  <Spin />
                </div>
              ) : (
                <Table columns={columns} dataSource={tasks} />
              )}
            </div>
          </div>
        </div>

        <NewTask
          open={isAddOpen}
          onClose={closeAddTask}
          onSuccess={handleAddTaskSuccess}
        />

        <TaskDetailDrawer
          mode={detailDrawer.mode}
          taskId={detailDrawer.taskId}
          open={detailDrawer.open}
          onClose={closeTaskDetail}
          onSuccess={handleEditTaskSuccess}
        />
      </div>
    </div>
  );
};

export default CRMTasks;
